import React, { useMemo } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'

import { Logo } from '@/components/common/Logo'
import { Breadcrumbs } from '@/components/layout/Breadcrumbs/Breadcrumbs'
import { UserMenuDropdown } from '@/components/layout/Header/UserMenuDropdown'

import { assessmentProcessPhasesDescription } from '../../../constants'
import { useAssessmentProcess } from '../../../contexts/AssessmentProcessContext'

export const AssessmentProcessHeader: React.FC = () => {
  const { id } = useParams<{ id: string }>()
  const location = useLocation()
  const navigate = useNavigate()
  const { assessment } = useAssessmentProcess()

  const breadcrumbItems = useMemo(() => {
    const items = [
      { label: 'Assessments', href: '/assessments' },
      { label: assessment?.organizacion?.nombre || '', href: undefined },
      { label: assessment?.codigo || `Assessment ${id}`, href: undefined }
    ]

    // Create step labels from constants
    const stepLabels: Record<string, string> = assessmentProcessPhasesDescription.reduce(
      (acc, phase) => {
        acc[phase.phase] = phase.title
        return acc
      },
      {} as Record<string, string>
    )

    const currentPath = location.pathname.split('/').pop()
    if (currentPath && stepLabels[currentPath]) {
      items.push({ label: stepLabels[currentPath], href: undefined })
    }

    return items
  }, [id, assessment, location.pathname])

  return (
    <header className="bg-white border-b border-gray-200 shadow-sm">
      <div className="px-4 ">
        <div className="flex items-center justify-between h-14">
          {/* Logo and Assessment Info */}
          <div className="flex items-center space-x-4 flex-shrink-0">
            <div className="w-32 flex-shrink-0">
              <button
                onClick={() => navigate('/assessments')}
                className="flex items-center hover:opacity-80 transition-opacity w-full justify-start pl-0"
                title="Volver a Assessments"
              >
                <Logo className="h-8" />
              </button>
            </div>
            <div className="h-8 w-px bg-gray-300 flex-shrink-0" />
            <div className="flex flex-col flex-shrink-0">
              <span className="text-sm font-semibold text-gray-900 whitespace-nowrap">
                {assessment?.nombre || 'Cargando assessment...'}
              </span>
            </div>
          </div>

          {/* Breadcrumbs */}
          <div className="flex-1 mx-8">
            <Breadcrumbs items={breadcrumbItems} />
          </div>

          {/* User Menu */}
          <div className="flex items-center space-x-4">
            <UserMenuDropdown />
          </div>
        </div>
      </div>
    </header>
  )
}
